import { useTranslation, useTranslations } from "@bsm/component";

export const useRefuseDayOffForm = () => {
    const [SELECT_REASON, REFUSE_REASON, CONFIRM] = useTranslations(i18n);
    const t = useTranslation()

    const REFUSE_REASONS = [
        { label: t("insufficient_balance"), value: "insufficient_balance" },
        { label: t("not_eligible"), value: "not_eligible" },
        { label: t("staffing_needs"), value: "staffing_needs" },
        { label: t("overlapping_request"), value: "overlapping_request" },
        { label: t("std_other"), value: "other" },
    ];

    return {
        data: {
            title: "",
            forms: [
                {
                    type: 'select',
                    name: 'refuseReason',
                    label: SELECT_REASON,
                    sortable: false,
                    options: REFUSE_REASONS,
                    placeholder: SELECT_REASON,
                },
                {
                    type: 'textarea',
                    name: 'customReason',
                    label: REFUSE_REASON,
                    placeholder: REFUSE_REASON,
                    rows: 4,
                    visible: (values: any) => values.refuseReason === 'other',
                },
            ],
            events: [
                {
                    name: "refuseReason",
                    type: "change" as const,
                    condition: [
                        { var_1: "${refuseReason}", op: "!=" as const, var_2: "other" },
                    ],
                    conditionIfRules: [
                        { name: "customReason", op: "hide" as const },
                    ],
                },
            ],
            next: {
                label: CONFIRM,
                endIcon: 'fas fa-check',
                className: 'btn-danger'
            },
        },
    };
};

const i18n = [
    "BSMRH.DayOff.Refuse.SelectReason",
    "std_reason",
    "std_confirm"
];
